import { defineMessages } from 'react-intl';

export default defineMessages({
    removeInfo: {
        id: 'quoteandbind.PELLinedirectives.templates.RemoveDisposalSites',
        defaultMessage: 'Remove Disposal Sites',
    },
    removeInfoDesc: {
        id: 'quoteandbind.PELLinedirectives.templates.DisposalSites',
        defaultMessage: 'Are you sure you want to remove this Disposal Sites from the list?',
    },
});